import styled from '@emotion/styled'

import { Carousel } from '@/components/Carousel'
import type { CardArticleEntryData } from '@/models'
import { CONFIG } from '@/styles/emotion.config'

import BlogHeroCarrosselButtons from './BlogHeroCarrosselButtons'
import BlogHeroCarrosselItem from './BlogHeroCarrosselItem'

const BlogHeroCarrosselStyles = styled(Carousel)`
  position: relative;
  margin-left: 0;
  margin-right: 0;

  .blog-hero__content {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    display: flex;
    padding: 0 1rem;
    flex-direction: column;
    justify-content: center;
    z-index: 2;
  }

  ${CONFIG.media.md} {
    .blog-hero__content {
      padding: 0 3rem;
    }
  }
`

interface Props {
  articles: CardArticleEntryData[]
}

const BlogHeroCarrossel = ({ articles }: Props) => (
  <BlogHeroCarrosselStyles
    className="eu-sm-4-r"
    renderButtons={BlogHeroCarrosselButtons}
    visibleCountDesktop={1}
    visibleCountMobile={1}
    full={true}
    itemGap={0}
  >
    {articles.map((article, index) => (
      <BlogHeroCarrosselItem key={`bhc-item-${article.id}`} item={article} index={index} />
    ))}
  </BlogHeroCarrosselStyles>
)

export default BlogHeroCarrossel
